import { NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { caretDownOutline } from 'ionicons/icons';
import ResizeObserver from 'resize-observer-polyfill';

let uniqueId = 0;

@Component({
  selector: 'app-expandable-para',
  templateUrl: './expandable-para.component.html',
  styleUrls: ['./expandable-para.component.scss'],
  imports: [NgClass, IonIcon]
})
export class ExpandableParaComponent implements AfterViewInit, OnDestroy {
  @Input() content: string;
  @ViewChild('para') paraElement: ElementRef<HTMLParagraphElement>;
  private resizeObserver: ResizeObserver;
  inputId = `expandable-para-input-${uniqueId++}`;
  constructor(public cdr: ChangeDetectorRef) {
    addIcons({ caretDownOutline });
  }

  ngOnDestroy(): void {
    this.resizeObserver.unobserve(this.paraElement.nativeElement);
    this.resizeObserver.disconnect();
  }

  ngAfterViewInit(): void {
    // Normally it would be good enough to call detectChanges here however
    // we see problems where the para element has zero height at this point
    // due to the way the slip modal is constructed i.e. whether it already
    // has the slip (i.e. from the slips list) or whether it has to be fetched
    // (i.e. from a slip message). In the second case the para has a height by
    // this point but in the first case not
    // and therefore the isTruncated returns false
    this.resizeObserver = new ResizeObserver(() => {
      if (this.paraElement.nativeElement.scrollHeight > 0) {
        this.cdr.detectChanges();
      }
    });
    this.resizeObserver.observe(this.paraElement.nativeElement);
  }

  isTruncated(param, expando): boolean {
    return expando.checked || param.scrollHeight > param.clientHeight;
  }
}
